import React from "react";
import { Select } from "components/form-component/select/select";
import { Input } from "components/form-component/input/input";
import {
  DataStyles,
  WrapperWidth,
  ButtonCTA,
  FormWrapper,
  LoginSpaceWrapper
} from "./user-profile-form.styles";
import { IUserProfileForm } from "./use-profile-form.types";
import { loginClassTypeOptions } from "constants/constants";
import { useLoginStudentForm } from "./hooks/use-login-student-form";

import UseClassOptionsChange from "./hooks/use-class-options-change";
import trackEvent from "services/mixpanel/mixpanel";
import { eventNames } from "services/mixpanel/events";
import { useAuth } from "stores/auth/auth-context";
import { parseStringtoNull } from "utils/utils";
import { LoginSuccessModal } from "./login-success-modal";

const LoginStudentForm = ({ userType }: IUserProfileForm): JSX.Element => {
  const {
    control,
    getValues,
    handleSubmit,
    isValid,
    onSubmit,
    isSuccessModalOpen,
    setIsSuccessModalOpen,
    isLoading
  } = useLoginStudentForm(userType);

  const headerMessage = {
    primaryText: "Hore! Profilmu udah jadi.",
    secondaryText: "Waktunya mulai menggapai cita-citamu"
  };

  const { gradeOptions, handleClassOptionsChange } =
    UseClassOptionsChange(getValues);
  const {
    user: { isWhatsappConsentGiven }
  } = useAuth();

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const gradeValue = event.target.value;
    trackEvent({
      eventName: eventNames.gradeSelected,
      payload: {
        incomingSource: "website",
        eventSource: "website",
        isOnboarded: false,
        referrer: typeof document !== "undefined" ? document.referrer : null,
        userRole: userType,
        whatsAppConsent: isWhatsappConsentGiven,
        grade: gradeValue.split("_")[0],
        stream: parseStringtoNull(gradeValue.split("_")[1])
      }
    });
  };

  return (
    <FormWrapper onSubmit={handleSubmit(onSubmit)}>
      <Input
        data-testid="name-field"
        name="name"
        label="Nama"
        control={control}
        placeholder="Isi namamu di sini. Pakai nama asli, ya!"
      />

      <DataStyles>
        <WrapperWidth width="60%">
          <Select
            testId="class-type-dropdown"
            name="classType"
            control={control}
            label="Jenjang sekolah"
            options={loginClassTypeOptions}
            placeholder="Pilih jenjang sekolah"
            onChange={handleClassOptionsChange}
          />
        </WrapperWidth>
        <WrapperWidth width="40%">
          <Select
            testId="grade-dropdown"
            name="grade"
            control={control}
            label="Kelas"
            options={gradeOptions}
            placeholder="Pilih kelas"
            onChange={handleChange}
          />
        </WrapperWidth>
      </DataStyles>
      <Input
        name="email"
        data-testid="email-field"
        label="Email anak"
        control={control}
        placeholder="Isi alamat email anak Anda di sini"
      />

      <LoginSpaceWrapper>
        <ButtonCTA
          disabled={!isValid}
          variant="primary"
          isLoading={isLoading}
          loadingText={"Membuat profil"}
          data-testid="register-profile-button">
          Buat profil
        </ButtonCTA>
      </LoginSpaceWrapper>

      <LoginSuccessModal
        isSuccessModalOpen={isSuccessModalOpen}
        setIsSuccessModalOpen={setIsSuccessModalOpen}
        headerMessage={headerMessage}
      />
    </FormWrapper>
  );
};

export { LoginStudentForm };
